import {Component, OnInit} from "@angular/core";

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
})
export class ProjectsComponent implements OnInit{

    constructor(){
    }

    ngOnInit(){
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/projects.component.ts